import Networks from "./networks"

export default Networks
